<template>
   <div class="confirmation-overlay width margin-left-3Perc container-fluid">
        <div id="myNav" class="overlay overlay-overall-width-100Perc" v-on:click="updateHideConfirmationOverlayFlag($event)">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-50Perc background-color-white fade-in" @click="noHide($event)">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc cursor-pointer" v-on:click="updateHideConfirmationOverlayFlag($event)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Point5Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row">
                  <div class="col-md-1 col-lg-1">
                  </div>
                  <div class="col-md-10 col-lg-10 black-font-color font-size-25px font-weight-bold">
                      {{alertTitle}}
                  </div>
                  <div class="col-md-1 col-lg-1">
                  </div>    
              </div>             
              <div class="row margin-bottom-5Perc margin-top-2Perc">
                  <div class="col-md-1 col-lg-1">
                  </div>
                  <div class="col-md-10 col-lg-10 font-size-16px" v-html="getMsgToDisplay">
                      <!-- {{getMsgToDisplay}} -->
                  </div>
                  <div class="col-md-1 col-lg-1">
                  </div>    
              </div>
              <div class="row margin-bottom-2Perc">
                  <div class="col-md-3 col-lg-3">
                  </div>
                  <!-- <div class="col-md-2 col-lg-2 cursor-pointer font-size-16px padding-Top-1Perc padding-Bottom-1Perc font-color-blue border" v-on:click="updateUserConfirmation($event,true)">
                      {{confirmationButtonText}}
                  </div> -->
                  <div class="col-md-3 col-lg-3 padding-Bottom-1Perc">
                    <button type="button" class="btn black-border custom-btn white-BG font-size-16px font-color-blue" v-on:click="updateUserConfirmation($event,true)">{{confirmationButtonText}}</button>
                  </div>
                  <!-- <div class="col-md-3 col-lg-3 cursor-pointer font-size-16px padding-Top-1Perc padding-Bottom-1Perc font-color-blue border" v-on:click="updateHideConfirmationOverlayFlag($event)">
                      {{cancelBtnText}}
                  </div> -->
                  <div class="col-md-3 col-lg-3 padding-Bottom-1Perc">
                      <button type="button" class="btn black-border custom-btn-cancel white-BG font-size-16px font-color-blue" v-on:click="updateHideConfirmationOverlayFlag($event)">{{cancelBtnText}}</button>
                  </div>
                  <div class="col-md-3 col-lg-3"></div>
              </div>
              <div class="row margin-top-1Perc margin-bottom-2Perc">
                  <div class="col-md-12 col-lg-12">
                  </div>
              </div>             
          </div>
      </div>
    </div> 
</template>
<script>
export default {
  props: ['dataObj', 'prefixString', 'postfixString'],
  name: 'confirmation-overlay',
  data: function () {
    return {
      alertTitle: 'Mentora Admin',
      confirmationButtonText: 'OK',
      cancelBtnText: 'Cancel'
    }
  },
  components: {},
  methods: {
    updateHideConfirmationOverlayFlag: function (event) {
      this.$emit('showConfirmationBox', false)
    },
    updateUserConfirmation: function (event, userConfirmationFlag) {
      this.$emit('userConfirmation', userConfirmationFlag)
    },
    noHide: function (event) {
      event.stopPropagation()
    }
  },
  computed: {
    getMsgToDisplay: {
      get: function () {
        if (
          this.dataObj === undefined ||
          this.dataObj === null ||
          this.dataObj.length === 0
        ) {
          return this.prefixString + this.postfixString
        } else {
          return (
            this.prefixString +
            '\'' +
            this.dataObj.Title +
            '\'' +
            this.postfixString
          )
        }
      }
    }
  },
  mounted () {
    var _this = this
    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 27) {
        _this.updateHideConfirmationOverlayFlag(event)
      }
    })
  }
}
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.56);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 30%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-50Perc {
  width: 50%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-1Perc {
  padding-top: 1%;
}
.padding-Bottom-1Perc {
  padding-bottom: 1%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-16px {
  font-size: 16px;
}
.font-size-25px {
  font-size: 25px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 3.5%;
  height: 3.5%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-1Point5Perc {
  margin-top: 1.5%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: dodgerblue;
}
.border {
  border: 1px solid #aaa;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.margin-bottom-5Perc {
  margin-bottom: 5%;
}
.black-border {
    border: 1px solid #aaa;
}
.custom-btn {
  padding: 7px 45px !important;
  border-radius:0px;
}
.custom-btn-cancel{
  padding: 7px 34px !important;
  border-radius:0px;
}
</style>


// WEBPACK FOOTER //
// src/components/ConfirmationOverlay.vue